import { useEffect, useRef, useState } from 'react'

/**
 * Watch a feature list go from empty → has items after it has loaded.
 * Does not fire on the first paint of an already-adopted venue, or on the
 * empty Redux store before the first fetch.
 */
export default function useJustAchievedFirstSuccess({
  loading = false,
  isEmpty = true,
  hasOutcome = false,
  pending = false,
} = {}) {
  const [justAchieved, setJustAchieved] = useState(false)
  const awaitingRef = useRef(false)
  const seenLoadedRef = useRef(false)
  const seenLoadingRef = useRef(false)

  useEffect(() => {
    if (loading) {
      seenLoadingRef.current = true
      return
    }
    const canShow = !isEmpty && hasOutcome
    if (pending && canShow) {
      awaitingRef.current = false
      seenLoadedRef.current = true
      setJustAchieved(true)
      return
    }
    if (!seenLoadedRef.current) {
      seenLoadedRef.current = true
      if (isEmpty && seenLoadingRef.current) awaitingRef.current = true
      return
    }
    if (isEmpty) {
      awaitingRef.current = true
      return
    }
    if (!awaitingRef.current || !hasOutcome) return
    awaitingRef.current = false
    setJustAchieved(true)
  }, [hasOutcome, isEmpty, loading, pending])

  return [justAchieved, setJustAchieved]
}
